<template>
  <tool-advance-filter-content
    :contentInfo="contentInfo"
    :addButtonText="addButtonText"
    :chartProperties="chartProperties"
    :chartData="chartGraphData"
    :linePlotData="linePlotData"
    :selectedComponent="superSelectedComponent"
    :updateButtonText="updateButtonText"
    :headers="headers"
    :rows="rows"
    :isNotShowGraph="isNotShowGraph"
    :singleHeading="singleHeading"
    :isShowHint="isShowHint"
    :infoText="infoText"
    :infoError="infoError"
    :baselineTitle="baselineRow ? baselineRow.title : ''"
    :headerbaseline="baselineHeader"
    :rowsbaseline="baselineRow ? baselineRow.rows : []"
    :emptyChartMessage="emptyChartMessage"
    @addRow="addRow"
    @editableRowButtonClick="genericMethodClick"
    @setFocusOnRowElement="setFocusOnRowElement"
    :focusElementName="focusElementName"
    :gridButtonTemplate="gridButtonTemplate"
    :singleHeadingOptions="singleHeadingOptions"
    :singleHeadingButtonText="singleHeadingButtonText"
    :gridSplitId="gridSplitId"
    @GridSelectionChange="AddNewTypeRow"
    :rowTemplateButton="rowTemplateButton"
    @rowTemplateButtonClick="genericMethodClick"
    @OuterRowButtonClick="genericMethodClick"
    :rowOuterButton="rowOuterButton"
    @onChange="OnOptionChange"
    :emptyGridData="emptyGridData"
    @removeRow="removeRow"
    @onChangeChartTab="onChangeSuperChartTab"
  ></tool-advance-filter-content>
</template>
<script>
import { ToolAdvanceFilterContent } from "../../component/tool";
import { AdvanceSuperFilter, PensionOption } from "../../helpers/constant";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  GET_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters } from "vuex";
import {
  EngagementBaseline,
  EngagementToolCommon,
  SuperannuationAdvanceFilterContent,
} from "../../mixin";
import _ from "lodash";
import { SuperFundType, PensionOptionType } from "../../helpers/constant";
export default {
  props: {
    baselineData: {
      type: Array,
    },
    clientId: {
      type: Number,
    },
    clientName: {
      type: String,
    },
  },
  components: { ToolAdvanceFilterContent },
  mixins: [
    EngagementBaseline,
    EngagementToolCommon,
    SuperannuationAdvanceFilterContent,
  ],
  mounted() {
    this.baselineHeader = this.getPensionBaselineHeader();
    this.baselineRow = {
      title: "Baseline Pension Payment",
      rows: this.getPensionbaselineRowData(),
    };
    this.getinsertEmptyRows(this.rows);

    this.contentInfo = {
      chartTabContent: this.getSuperTimeSeriesChartTab(),
      heading: ` ${this.clientName} Pension Payment`,
      subHeading:
        "You can enter in different return at different time periods.",
      infoAlert: {
        title: "Important note",
        variation: "informational",
        text: "You can enter in different return at different time periods.",
      },
    };
  },
  computed: {
    ...mapGetters("superannuation", {
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
    legendItems() {
      return ["", "Additional Pension Payment"];
    },

    gridButtonTemplate() {
      let difference = true;
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let ExistingData = Superannuations[0].superAddtionalDetails
        .filter(
          (sr) =>
            sr.typeId == AdvanceSuperFilter.PensionPayment &&
            sr.clientID == this.clientId
        )
        .map(function (t) {
          let p = {};
          p.amount1 = t.amount1;
          //  p.index = t.index;
          //  p.frequency = t.frequency;
          p.description = t.description;
          p.startDate = t.startDate;
          p.startDateType = t.startDateType;
          p.endDate = t.endDate;
          p.endDateType = t.endDateType;
          //    p.effectiveAsOn = t.effectiveAsOn;
          p.clientID = t.clientID;
          return p;
        });

      let CurrentDataObject = [];
      if (this.rows)
        for (let i = 0; i < this.rows.length; i++) {
          if (ExistingData && ExistingData.length > 0)
            CurrentDataObject.push({
              amount1: this.rows[i].amount1.value,
              //  index: this.rows[i].index.value,
              //   frequency: this.rows[i].frequency.value,
              description: this.rows[i].description.value,
              startDate: this.rows[i].startDate.value,
              startDateType: this.rows[i].startDateType.value,
              endDate: this.rows[i].endDate.value,
              endDateType: this.rows[i].endDateType.value,
              //  effectiveAsOn: this.rows[i].effectiveAsOn.value,
              clientID:
                this.rows[i].clientID == undefined
                  ? this.clientId
                  : this.rows[i].clientID.value,
            });
          else {
            if (
              !this.validatebyrow(this.rows[i], this.rows[i].subTypeId.value)
            ) {
              difference = false;
              break;
            }
          }
        }
      if (ExistingData && ExistingData.length > 0) {
        difference = _.isEqual(ExistingData, CurrentDataObject);
      }
      this.enableResetButton(difference, "UpdateGraph");
      this.enableResetButton(difference, "reset");

      return this.gridButtonTemplatedata;
    },
    baselineFilterObject() {
      return Object.assign({}, this.baselineData);
    },
  },

  watch: {
    clientId: function () {
      this.rows = this.fillGrid();
    },
  },

  data() {
    return {
      emptyGridData: {
        title: "Click to add Additional Drawdowns",
        message: "",
        imagepath: "../../assets/icons/dollar.svg",
        buttonVisible: true,
        list: [],
      },
      rowOuterButton: [],
      focusElementName: "",
      rowTemplateButton: [
        {
          icon: "plus",
          size: "medium",
          variation: "flat",
          text: "Add New",
          callBackMethod: "AddNewTypeRow",
          isdisabled: false,
          key: "AddNewTypeRow",
        },
      ],
      gridButtonTemplatedata: [
        {
          icon: "eye",
          size: "medium",
          variation: "primary",
          text: "Preview Graph",
          callBackMethod: "UpdateGraph",
          isdisabled: false,
          key: "UpdateGraph",
        },
        {
          size: "medium",
          variation: "secondary",
          isdisabled: true,
          text: "Reset",
          callBackMethod: "reset",
          key: "reset",
        },
      ],
      timeSeriesChartData: [],
      emptyChartMessage: {
        message: "Add Drawdown details to create a chart.",
        btnTxt: "",
      },

      updateButtonText: "Update Graph",
      addButtonText: "Add new",
      isShowHint: true,
      infoText: ["Hit 'Tab' to move to the next cell and add a new row"],
      singleHeadingOptions: [
        {
          key: 1,
          value: "Regular",
          fields: [
            "superTypeId",
            "amount1",
            // "index",
            // "frequency",
            "startDate",
            "endDate",
            "description",
          ],
          overlapvalidations: true,
        },
        {
          key: 2,
          value: "Lump Sum",
          fields: [
            "superTypeId",
            "amount1",
            "startDate",
            "description",
            // "effectiveAsOn",
          ],
          overlapvalidations: false,
          showDateLabel: true,
        },
      ],
      singleHeadingButtonText: "",
      contentInfo: {},
      gridSplitId: "subTypeId",
      infoError: false,
      singleHeading: "Pension Payment Adjustment",
      headers: [
        {
          type: "Dropdown",
          label: "Type",
          cols: 1,
          key: "superTypeId",
          options: PensionOption,
          defaultValue: "1",
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        {
          type: "FormatInput",
          label: "Amount",
          cols: 2,
          key: "amount1",
          isAllowOnlyNumber: true,
          appendText: "",
          currencyFormat: "$,",

          max: 999999999,
          length: 9,
          validation: true,
          style: {
            width: "160px",
            overflow: "visible",
          },
        },
        // {
        //   type: "Dropdown",
        //   label: "Index",
        //   cols: 1,
        //   key: "index",
        //   options: this.indexOptions(),
        //   defaultValue: "AWOTE",
        //   validation: true,
        // },
        // {
        //   type: "Dropdown",
        //   label: "Frequency",
        //   cols: 1,
        //   key: "frequency",
        //   options: this.frequencyOption(),
        //   defaultValue: "Weekly",
        //   validation: true,
        // },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "Start",
          text: "Date",
          cols: 2,
          key: "startDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        // {
        //   type: "Dropdown",
        //   label: "Effective as on",
        //   cols: 2,
        //   Option: "",
        //   key: "effectiveAsOn",
        //   options: [
        //     {
        //       text: "Start of the month",
        //       value: "1",
        //     },
        //     {
        //       text: "End of the month",
        //       value: "2",
        //     },
        //   ],
        //   defaultValue: 1,
        //   validation: true,
        // },

        {
          type: "MonthPickerSelect",
          displayTop: true,
          typing: true,
          label: "End",
          cols: 2,
          key: "endDate",
          listdata: this.startOptionsNew(),
          sort: "years",
          minYear: 2022,
          yearTerm: 50,

          style: {
            width: "160px",
            overflow: "visible",
          },
          validation: true,
        },
        {
          type: "Input",
          label: "Description",
          placeholder: "e.g Change in Rates",
          isAllowToAddNextRow: true,
          cols: 2,
          Option: "",
          key: "description",
          length: 200,
        },

        {
          type: "Icon",
          label: "",
          iconText: "Validation",
          icon: "check",
          cols: 1,
          isShowDelete: true,
          isShowSuccess: false,
          class: "cf-Icon-Align",
          style: {
            width: "50px",
          },
          data: [
            {
              label: "",
              iconText: "Delete",
              icon: "trash",
              type: "icon",
              path: "",
              action: "delete",
            },
          ],
        },
      ],
      rows: this.fillGrid(),
      baselineHeader: [],
      baselineRow: {},
      selectedFundType: SuperFundType.Pension,
      selectedOption: AdvanceSuperFilter.PensionPayment,
    };
  },
  async created() {},
  beforeMount() {
    this.fillSuperannuationModel(AdvanceSuperFilter.PensionPayment);
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.PensionPayment,
      this.clientId
    );
  },
  beforeDestroy() {
    this.fillSuperannuationModel(
      AdvanceSuperFilter.PensionPayment,
      this.clientId
    );
    this.superValidations(
      this.baselineFilterObject.superAddtionalDetails,
      AdvanceSuperFilter.PensionPayment,
      this.clientId
    );
  },
  methods: {
    async UpdateGraph() {
      await this.updateAllAdvanceSuperGraph(
        AdvanceSuperFilter.PensionPayment,
        this.clientId
      );
    },
    fillGrid() {
      let gridRows = [];
      if (this.baselineData.superAddtionalDetails != null) {
        let data = this.baselineData.superAddtionalDetails.filter(
          (sr) =>
            sr.typeId.value == AdvanceSuperFilter.PensionPayment &&
            sr.clientID.value == this.clientId
        );
        if (data != null && data.length > 0) {
          gridRows = this.emptyGridRow(data);
        }
      }

      return gridRows;
    },
    getUserInputData(rows) {
      let addtionalData = [];
      if (this.rows)
        for (let i = 0; i < rows.length; i++) {
          if (!this.validatebyrow(rows[i], rows[i].subTypeId.value)) {
            addtionalData.push({
              amount1: {
                value: rows[i].amount1.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].amount1.disable,
              },
              // index: {
              //   value: rows[i].index.value,
              //   IsError: false,
              //   ErrorText: [],
              //   disable: rows[i].index.disable,
              // },
              // frequency: {
              //   value: rows[i].frequency.value,
              //   IsError: false,
              //   ErrorText: [],
              //   disable: rows[i].frequency.disable,
              // },
              startDateType: {
                value:
                  rows[i].startDate.value == undefined
                    ? 0
                    : rows[i].startDate.value.value == undefined
                    ? rows[i].startDateType.value
                    : rows[i].startDate.value.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].startDateType.disable,
              },
              startDate: {
                value:
                  rows[i].startDate.value == undefined
                    ? 0
                    : rows[i].startDate.value.meta == undefined
                    ? rows[i].startDate.value
                    : rows[i].startDate.value.meta,
                IsError: false,
                ErrorText: [],
                disable: rows[i].startDate.disable,
              },
              endDateType: {
                value:
                  rows[i].endDate.value == undefined
                    ? 0
                    : rows[i].endDate.value.value == undefined
                    ? rows[i].endDateType.value
                    : rows[i].endDate.value.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].endDateType.disable,
              },
              // effectiveAsOn: {
              //   value: rows[i].effectiveAsOn.value,
              //   IsError: false,
              //   ErrorText: [],
              //   disable: rows[i].effectiveAsOn.disable,
              // },
              endDate: {
                value:
                  rows[i].endDate.value == undefined
                    ? 0
                    : rows[i].endDate.value.meta == undefined
                    ? rows[i].endDate.value
                    : rows[i].endDate.value.meta,
                IsError: false,
                ErrorText: [],
                disable: rows[i].endDate.disable,
              },
              description: {
                value: rows[i].description.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].description.disable,
              },
              superTypeId: {
                value: rows[i].superTypeId.value,
                IsError: false,
                ErrorText: [],
                disable: rows[i].superTypeId.disable,
              },
              typeId: {
                value: AdvanceSuperFilter.PensionPayment,
                IsError: false,
                ErrorText: [],
              },
              subTypeId: {
                value: rows[i].subTypeId.value,
                IsError: false,
                ErrorText: [],
              },
              clientID: {
                value:
                  rows[i].clientID.value == undefined
                    ? this.clientId
                    : rows[i].clientID.value,
                IsError: false,
                ErrorText: [],
              },
              newRow: false,
            });
          }
        }
      return addtionalData;
    },

    setFocusOnRowElement() {
      this.focusElementName = this.headers[0].key + "0";
    },
    //     getbaselineRowData() {
    //       let baseContributionData = Object.assign([], this.baselineData);
    //       let contributionData = baseContributionData.filter(
    //         (sr) =>
    //           sr.clientId == this.clientId && sr.contribution != null
    //       );
    // let conData = contributionData[0].contribution;
    //       if (contributionData.length != 0) {
    //         contributionData.push({
    //           contributionAmount: conData.employerAmount,
    //           durationTypeId: conData.employerDurationType,
    //         })}
    //       //   else{
    //       //     Condata.push({
    //       //       employerAmount: Condata.employerAmount,
    //       //       employerdurationType: Condata.employerdurationType,
    //       //   });
    //       // }
    //        return this.resetContribution(contributionData[0]);
    //     },

    resetContribution(contribution) {
      return [
        {
          employerAmount: { value: contribution.employerAmount },
          employerdurationType: {
            value: contribution.employerdurationType,
          },
        },
      ];
    },

    fillData(data, subTypeid) {
      let IsDataundfined = data == undefined;
      let startDateType = IsDataundfined
        ? 0
        : data.startDateType.value == 0
        ? 6
        : data.startDateType.value;
      let endDateType = IsDataundfined
        ? 0
        : data.endDateType.value == 0
        ? 6
        : data.endDateType.value;
      let emptyObject = {
        subTypeId: {
          value: IsDataundfined ? subTypeid : data.subTypeId.value,
          IsError: IsDataundfined ? false : data.subTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.subTypeId.ErrorText,
          disable: IsDataundfined ? false : data.subTypeId.disable,
        },
        // index: {
        //   value: IsDataundfined ? 0 : data.index.value,
        //   IsError: IsDataundfined ? false : data.index.IsError,
        //   ErrorText: IsDataundfined ? [] : data.index.ErrorText,
        //   disable: IsDataundfined ? false : data.index.disable,
        // },
        typeId: {
          value: IsDataundfined
            ? AdvanceSuperFilter.PensionPayment
            : data.typeId.value,
          IsError: IsDataundfined ? false : data.typeId.IsError,
          ErrorText: IsDataundfined ? [] : data.typeId.ErrorText,
          disable: IsDataundfined ? false : data.typeId.disable,
        },
        superTypeId: {
          value: IsDataundfined ? 0 : data.superTypeId.value,
          IsError: IsDataundfined ? false : data.superTypeId.IsError,
          ErrorText: IsDataundfined ? [] : data.superTypeId.ErrorText,
          disable: IsDataundfined ? false : data.superTypeId.disable,
        },
        amount1: {
          value: IsDataundfined ? 0 : data.amount1.value,
          IsError: IsDataundfined ? false : data.amount1.IsError,
          ErrorText: IsDataundfined ? [] : data.amount1.ErrorText,
          disable: IsDataundfined
            ? false
            : data.superTypeId.value != PensionOptionType.Other
            ? true
            : data.amount1.disable,
        },
        // frequency: {
        //   value: IsDataundfined ? 0 : data.frequency.value,
        //   IsError: IsDataundfined ? false : data.frequency.IsError,
        //   ErrorText: IsDataundfined ? [] : data.frequency.ErrorText,
        //   disable: IsDataundfined ? false : data.frequency.disable,
        // },
        startDateType: {
          value: IsDataundfined ? 0 : data.startDateType.value,
          IsError: IsDataundfined ? false : data.startDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.startDateType.ErrorText,
          disable: IsDataundfined ? false : data.startDateType.disable,
        },
        startDate: {
          value: IsDataundfined ? "" : data.startDate.value,
          IsError: IsDataundfined ? false : data.startDate.IsError,
          ErrorText: IsDataundfined ? [] : data.startDate.ErrorText,
          text: IsDataundfined
            ? ""
            : this.startOptionsNew().filter((x) => x.value == startDateType)[0]
                .text,
        },
        endDateType: {
          value: IsDataundfined ? 0 : data.endDateType.value,
          IsError: IsDataundfined ? false : data.endDateType.IsError,
          ErrorText: IsDataundfined ? [] : data.endDateType.ErrorText,
          disable: IsDataundfined ? false : data.endDateType.disable,
        },
        endDate: {
          value: IsDataundfined ? "" : data.endDate.value,
          IsError: IsDataundfined ? false : data.endDate.IsError,
          ErrorText: IsDataundfined ? [] : data.endDate.ErrorText,
          text:
            IsDataundfined || data.endDate.value == ""
              ? ""
              : this.startOptionsNew().filter((x) => x.value == endDateType)[0]
                  .text,
        },
        // effectiveAsOn: {
        //   value: IsDataundfined ? 0 : data.effectiveAsOn.value,
        //   IsError: IsDataundfined ? false : data.effectiveAsOn.IsError,
        //   ErrorText: IsDataundfined ? [] : data.effectiveAsOn.ErrorText,
        //   disable: IsDataundfined ? false : data.effectiveAsOn.disable,
        // },
        description: {
          value: IsDataundfined ? "" : data.description.value,
          IsError: IsDataundfined ? false : data.description.IsError,
          ErrorText: IsDataundfined ? [] : data.description.ErrorText,
          disable: IsDataundfined ? false : data.description.disable,
        },
        clientID: {
          value: IsDataundfined ? this.clientId : data.clientID.value,
        },
        newRow: IsDataundfined ? true : false,
      };
      return emptyObject;
    },
    emptyGridRow(data) {
      if (data == undefined) {
        return this.fillData();
      } else {
        let gridData = [];
        for (let i = 0; i < data.length; i++) {
          gridData.push(this.fillData(data[i]));
        }
        return gridData;
      }
    },

    reset() {
      let Superannuations = this.getSuperannuationInformation.filter(
        (sr) =>
          sr.superFundGuid == this.selectedSuperannuationData.superFundGuid
      );
      let selectedRepData = Superannuations[0].superAddtionalDetails.filter(
        (sr) =>
          sr.typeId == AdvanceSuperFilter.PensionPayment &&
          sr.clientID == this.clientId
      );
      if (selectedRepData.length > 0) {
        let advanceData = [];
        for (let i = 0; i < selectedRepData.length; i++) {
          advanceData.push({
            subTypeId: {
              value: selectedRepData[i].subTypeId,
            },
            amount1: {
              value: selectedRepData[i].amount1,
            },
            startDate: {
              value: selectedRepData[i].startDate,
            },
            startDateType: {
              value: selectedRepData[i].startDateType,
            },
            endDate: {
              value: selectedRepData[i].endDate,
            },
            endDateType: {
              value: selectedRepData[i].endDateType,
            },
            description: {
              value: selectedRepData[i].description,
            },
            superTypeId: {
              value: selectedRepData[i].superTypeId,
            },
            typeId: {
              value: AdvanceSuperFilter.PensionPayment,
            },
            // effectiveAsOn: {
            //   value: selectedRepData[i].effectiveAsOn,
            // },
            // index: {
            //   value: selectedRepData[i].index,
            // },
            // frequency: {
            //   value: selectedRepData[i].frequency,
            // },
            clientID: {
              value: selectedRepData[i].clientID,
            },
          });
        }
        this.rows = advanceData;
      } else {
        this.rows = [];
        this.getinsertEmptyRows(this.rows);
      }
      this.enableResetButton(false, "reset");
    },
  },
};
</script>
<style lang="scss" module></style>
